import * as Lucide from "lucide-react";

// Generic icon renderer by name (keeps section files lean).
export default function Icon({ name, ...props }) {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp {...props} />;
}
